<template>
    <div class="flex flex-wrap gap-2">
        <Chip v-for="incident in props.incidents" :key="incident.id" :label="incident.incident_number" removable @remove="emit('remove-user', incident.id)" />
        <!-- Show remove all button once there are more than 1 user selected -->
        <Button v-if="incidentsCount > 1" label="Remove all selected" severity="danger" @click="removeAll" />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useConfirmRemove } from '@/composables/ConfirmComposable';

const emit = defineEmits(['remove-user', 'remove-all-selected']);

const props = defineProps({
    incidents: Array,
});

const { confirmContinue } = useConfirmRemove();

const incidentsCount = computed(() => {
    return props.incidents?.length;
});

const removeAll = async () => {
    const message = 'Remove all selected users.';
    const confirm = await confirmContinue(message);
    if (confirm) {
        emit('remove-all-selected');
    }
};
</script>
